import { AfterViewInit, Component, ViewChild } from '@angular/core';

import { BackEndService } from '../../Services/back-end.service';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
// @ts-ignore
import { Router } from '@angular/router';

export class FoodNode {
  name: string;
  value: string;
  children?: FoodNode[];
  deserialize(input: any) {
    Object.assign(this, input);
    this.children = input.children.map(node => new FoodNode().deserialize(node));
    return this;
  }
}

@Component({
  selector: 'app-folder-tree',
  templateUrl: './folder-tree.component.html',
  styleUrls: ['./folder-tree.component.css']
})
export class FolderTreeComponent implements AfterViewInit {
  @ViewChild('tree', { read: true, static: true }) tree;
  constructor(private backEndService: BackEndService, private router: Router) {

    var tmpToken = sessionStorage.getItem('token');
    if (tmpToken == null || tmpToken == 'null')
      this.router.navigate(['/Login']);

    this.treeControl = new NestedTreeControl<FoodNode>(this.getChildren);
    this.dataSource = new MatTreeNestedDataSource<FoodNode>();
    backEndService.GetFolders().subscribe(
      res => {
        this.Posts = res;
        this.getRes();

        this.dataSource.data = res;
        this.treeControl.dataNodes = this.dataSource.data;
        this.treeControl.expandAll();
      },
      err => {
        console.log(err);
      });
  }
  treeControl: NestedTreeControl<FoodNode>;
  dataSource: MatTreeNestedDataSource<FoodNode>;

  hasChild = (_: number, node: FoodNode) => !!node.children && node.children.length > 0;

  Posts: any[];
  tt: FoodNode[];
  private filename: string;
  tmps: string;

  getRes() {
    console.log(this.Posts);
    this.tt = this.Posts;
    console.log(this.tt);
  }

  private getChildren = (node: FoodNode) => node.children;

  ngAfterViewInit() {
    console.log('ngAfterViewInit');
  }

  DownloadFile(filename: string) {
    window.open(filename);
  }
}
